import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';

const PublicRoute = ({ children }) => {
  
    const tokenEmpresa = useSelector(state => state.token.tokenEmpresa);
    const tokenAdmin = useSelector(state => state.token.tokenAdmin);
    const token = localStorage.getItem('token');

  const isTokenExpired = (token) => {
      if (!token) return true;

      const decodedToken = jwtDecode(token);
      const expirationDate = new Date(decodedToken.exp * 1000);
      return expirationDate < new Date();
  };

  const isAuthenticated = () => {
      return token && !isTokenExpired(token);
  };

  if (isAuthenticated()) {
      if (token === tokenEmpresa) {
          return <Navigate to="/" replace />;
      };
      if (token === tokenAdmin) {
          return <Navigate to="/admin/home" replace />;
      };
  };

  return children;
};

export default PublicRoute;